<template>
  <div :style="bgAndTextColor" class="badge">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'dx-badge',
  props: {
    color: {
      type: String,
      default: 'grey-semi-light',
    },
    textColor: {
      type: String,
      default: 'grey-dark',
    },
  },
  computed: {
    bgAndTextColor() {
      return `background-color: var(--dx-color--${this.color}); color: var(--dx-color--${this.textColor})`;
    },
  },
};
</script>

<style lang="scss" scoped>
.badge {
  padding: 4px 16px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
